import { useState } from "react";
import { RenderLightBoxImage } from ".";

export default function useLightBox () {
    const [lightBoxOpen, setLightBoxOpen] = useState(false);
    const [images, setImages] = useState<Array<RenderLightBoxImage>>([]);
    
    return {
        lightBoxOpen, 
        setLightBoxOpen,
        images, 
        setImages
    }
}